import React from 'react';
import { motion } from 'framer-motion';
import { LightbulbIcon, CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full px-4 py-20 bg-[#1e293b]" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="text-3xl md:text-5xl font-black mb-12 flex items-center justify-center gap-3" data-id="element-119">
            <LightbulbIcon className="w-10 h-10 text-yellow-400" data-id="element-120" />
            Imaginate esto
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 mb-12" data-id="element-121">
            <p className="text-center leading-relaxed" data-id="element-122">Entrás a cada sesión…</p>
            <p className="text-center text-2xl font-bold text-white" data-id="element-123">
              Y ya sabés exactamente:
            </p>

            <div className="bg-gradient-to-br from-yellow-400/10 to-yellow-400/5 border border-yellow-400/30 p-8 rounded-lg mt-8" data-id="element-124">
              <div className="space-y-4" data-id="element-125">
                {['cómo evaluar', 'qué protocolo usar', 'qué ejercicios aplicar', 'cómo registrar todo'].map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.1 * index
              }} className="flex items-center gap-3" data-id="element-126">
                    <CheckCircle2Icon className="w-6 h-6 text-yellow-400 flex-shrink-0" data-id="element-127" />
                    <span className="text-xl font-semibold" data-id="element-128">{item}</span>
                  </motion.div>)}
              </div>
            </div>

            <p className="text-center leading-relaxed mt-8" data-id="element-129">
              Sin estresarte. Sin improvisar.
            </p>
            <p className="text-center text-3xl font-black text-yellow-400" data-id="element-130">
              👉 Solo ejecutar.
            </p>
          </div>

          <div className="text-center" data-id="element-131">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={scrollToCompra} className="bg-yellow-400/90 text-black px-8 py-4 rounded-lg font-bold text-lg inline-flex items-center gap-2 shadow-lg shadow-yellow-400/20" data-id="element-132">
              Quiero este sistema
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}